module.exports = __webpack_public_path__ + "img/youtube.a657c01e.png";